import { IGetAtividadeObraResponsavelDropDownUseCase } from "../../../presentation/useCases/read/get_atividade_obra_responsavel_drop_down_use_case";
import { AtividadeObraFuncionario } from "../../models/atividade_obra_funcionario";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAtividadeObraResponsavelDropDownUseCase
 */

export class GetAtividadeObraResponsavelDropDownUseCase implements IGetAtividadeObraResponsavelDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getAtividadeObraResponsavelDropdown(
    idFuncionarioResponsavel?: number,
  ): Promise<AtividadeObraFuncionario[]> {
    return await this.repository.getAtividadeObraResponsavelDropdown(idFuncionarioResponsavel ?? null);
  }
}
